import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';

export enum LinkPreviewProviders {
  Instagram = 'Instagram',
  Twitter = 'Twitter',
  YouTube = 'YouTube',
  TikTok = 'TikTok',
}

export const socialModals = {
  instagram: `${Node_Type.LINK_PREVIEW}.instagram`,
  facebook: `${Node_Type.LINK_PREVIEW}.facebook`,
  tiktok: `${Node_Type.LINK_PREVIEW}.tiktok`,
  twitter: `${Node_Type.LINK_PREVIEW}.twitter`,
  pinterest: `${Node_Type.LINK_PREVIEW}.pinterest`,
};

export const linkPreviewModals = {
  settings: `${Node_Type.LINK_PREVIEW}.settings`,
};
